import React from "react";
import Header from "../components/FrontPage/Header/Header";
import Footer from "../components/Footer/Footer";
import LeftDrawer from "../components/Dashboard/Drawers/LeftDrawer";
import VatRefund from "./static/VATrefund";
import ScrollToTopOnMount from "../helpers/ScrollToTop";

const VatRefundPage = ({ USER }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <Header />
      <VatRefund />
      <Footer />
      {USER && <LeftDrawer small />}
    </>
  );
};

export default VatRefundPage;
